import { render, staticRenderFns } from "./copyCandidateDialog.vue?vue&type=template&id=b9722f7c&scoped=true"
import script from "./copyCandidateDialog.vue?vue&type=script&lang=js"
export * from "./copyCandidateDialog.vue?vue&type=script&lang=js"
import style0 from "./copyCandidateDialog.vue?vue&type=style&index=0&id=b9722f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9722f7c",
  null
  
)

export default component.exports